<div class="popup-div">
  <p (click)="routeToPath(option.path)" *ngFor="let option of options">{{option.value}}</p>
  <!-- <p [routerLink]="['/leads']">test</p> -->
</div>